import { Controller } from '@hotwired/stimulus';
import { noop } from 'lodash';

// FIXME: Migrar y no utilizar Marionette, es muy fácil de migrar
/* global $, Mn */
const SelectorAlumnoCursos = Mn.View.extend({
  template: noop,
  events: {
    'click .btn-seleccion-curso': 'seleccionCurso',
  },
  // eslint-disable-next-line object-shorthand
  seleccionCurso: function (e) {
    // Alumno seleccionado
    const alumnoId = $(e.currentTarget).data('alumno-id');
    // Curso seleccionado
    const cursoSeleccionado = this.$el.find('#cursos').find(':selected');
    if (alumnoId) {
      const $cursoHolder = $('body').find(`.seleccion-curso-holder[data-alumno-id=${alumnoId}]`);
      $cursoHolder.find('input:hidden.solo-curso').val(cursoSeleccionado.val());
      $cursoHolder.find('.curso-seleccionado').html(cursoSeleccionado.text());
    }
    // Cerrar el modal
    $('#modal-selector-alumno-cursos').modal('hide');
  },
});

export default class extends Controller {
  connect() {
    new SelectorAlumnoCursos({ el: this.element }).render();
  }
}
